import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import DetailsRow from "./DetailsRow";
import EditForm from "./EditForm";
import PriceForm from "./PriceForm";
import { useTranslation } from "react-i18next";
import {
  updateProduct,
  updateProductPricing,
} from "../../../../redux/reducer/productReducer";

const DetailsTable = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  isPricing,
  setEditingOrder,
  setPricingOrder,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { areas, loadingAreas } = useSelector((state) => state.areas);

  // State for price form and edit form
  const [priceForm, setPriceForm] = useState({
    name: "",
    price: "",
    DShippingFees: "",
    area: "",
  });
  const [editForm, setEditForm] = useState({
    name: details.name || "",
    price: details.price || "",
    DShippingFees: details.DShippingFees || "",
    area: details?.area || "",
  });
  // console.log(editForm)
  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };

  const handleEdit = () => {
    setEditForm({
      name: details.name || "",
      price: details.price || "",
      DShippingFees: details.DShippingFees || "",
      area: details?.area || "",
    });
    setEditingOrder(details.id);
    setPricingOrder(null);
  };

  const handlePrice = () => {
    setPriceForm({
      name: details.Name,
      price: details.price || "",
      DShippingFees: details.DShippingFees || "",
      area: details.area || "",
    });
    setPricingOrder(details.id);
    setEditingOrder(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    // console.log(editForm)
    dispatch(updateProduct({ id: details.id, data: editForm }))
      .unwrap()
      .then(() => {
        if (onUpdate) onUpdate(editForm);
        refreshData();
      });
    setEditingOrder(null);
  };

  const handlePriceSubmit = (e) => {
    e.preventDefault();
    // console.log(priceForm)
    if (
      !priceForm.name ||
      !priceForm.price ||
      !priceForm.DShippingFees ||
      !priceForm.area
    ) {
      alert(t("priceRequired"));
      return;
    }

    const finalForm = {
      ...priceForm,
    };

    // console.log("Final priceForm JSON data:", finalForm);

    dispatch(updateProductPricing({ id: details.id, data: finalForm }))
      .unwrap()
      .then(() => {
        if (refreshData) refreshData();
      });
    setPricingOrder(null);
  };

  // console.log(areas)
  return (
    <>
      <DetailsRow
        details={details}
        onDelete={onDelete}
        areas={areas}
        onPrice={handlePrice}
        onEdit={handleEdit}
        getLinkButton={getLinkButton}
        refreshData={refreshData}
      />
      {(isPricing || isEditing) && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          {isEditing ? (
            <EditForm
              editForm={editForm}
              onChange={handleEditChange}
              onSubmit={handleEditSubmit}
              onCancel={() => setEditingOrder(null)}
              areas={areas}
              loadingAreas={loadingAreas}
            />
          ) : (
            <PriceForm
              priceForm={priceForm}
              onChange={handlePriceChange}
              onSubmit={handlePriceSubmit}
              onCancel={() => setPricingOrder(null)}
              areas={areas}
              loadingAreas={loadingAreas}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DetailsTable;
